import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";
import { down } from "../../styles/breakpoints";
import { pageShellRoot } from "../../styles/pageShell";

const useStyles = createUseStyles((_) => ({
  vehiculeRoot: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    minWidth: 0,
    backgroundColor: colors.bgcolor,
  },

  contentMain: pageShellRoot,

  container: {
    width: "100%",
    minWidth: 0,
  },

  banner: {
    "& >div": {
      display: "flex",
      alignItems: "end",
      /* `calc(60% + 300px)` mirrored the old two-column widths by hand, so
         the banner content stopped lining up the moment the columns below
         reflowed. It now simply respects the page gutter. */
      width: "min(100% - 40px, 1200px)",
      margin: "auto",
      gap: "30px",
      flexWrap: "wrap",
    },
    minHeight: 174,
    display: "flex",
    background:
      "linear-gradient(90deg, rgba(255,0,0,1) 0%, rgba(255,111,8,1) 100%)",
    [down.sm]: {
      minHeight: 130,
      "& >div": {
        gap: "16px",
        width: "calc(100% - 24px)",
      },
    },
  },

  titleVehicule: {
    fontFamily: "Poppins-Light",
    fontSize: "clamp(20px, 4vw, 30px)",
    lineHeight: 1.3,
    color: "#312B27",
    textTransform: "uppercase",
    overflowWrap: "anywhere",
  },
  titlevehicule2: {
    fontFamily: "Poppins-Black",
    fontSize: 24,
    color: "#312B27",
  },
  titleNumber: {
    fontFamily: "Poppins-Black",
    fontSize: 24,
    color: "#FF6F08",
    lineHeight: "15px",
  },
  content: {
    display: "flex",
    justifyContent: "center",
    padding: "30px 20px 0",
    gap: "20px",
    minWidth: 0,
    [down.lg]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
    [down.sm]: {
      padding: "20px 12px 0",
    },
  },

  contentLeft: {
    width: 300,
    flexShrink: 0,
    minWidth: 0,
    [down.lg]: {
      width: "100%",
    },
  },

  /*
   * `minWidth: 600px` was the worst offender on this page: it applied at every
   * size below 1200px too (the override there only lowered it to 300px), so
   * between the 300px left column, the sidebar and the gutters the layout
   * demanded ~1000px and any narrower window scrolled sideways.
   */
  contentRight: {
    flex: "1 1 auto",
    width: "60%",
    minWidth: 0,
    [down.lg]: {
      width: "100%",
    },
  },
  title: {},
  subtitle: {
    margin: "40px 0px 50px",
    "& div:first-child": {
      fontFamily: "Poppins-Regular",
      fontSize: 12,
      color: "#ADADAD",
    },
    "& div:last-child": {
      borderBottom: "1px solid #ADADAD",
    },
  },
  menulist: {
    borderBottom: "1px solid #ADADAD",
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 0",
    "& div:first-child": {
      fontFamily: "Poppins-Regular",
      fontSize: 12,
      color: "#ADADAD",
      flex: "0 0 auto",
    },
    "& div:last-child": {
      fontFamily: "Poppins-Regular",
      fontSize: 12,
      color: "#312B27",
      textAlign: "right",
      // Allow text to wrap if needed
      wordWrap: "break-word",
      marginLeft: "10px",
    },
  },
  containerInformation: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "16px",
    justifyContent: "flex-end",
    margin: "0px 20px 7px",
    [down.sm]: {
      flexDirection: "column",
      alignItems: "flex-end",
      margin: "0px 12px 7px",
    },
  },
  information: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
    alignItems: "center",
    // Ensure content doesn't get cut off
    minHeight: "24px",
  },
  textInformation: {
    fontFamily: "Poppins-Italic",
    fontSize: "10px",
    textWrap: "nowrap",
    [down.sm]: {
      textWrap: "wrap",
    },
  },

  historique: {
    border: "1px solid #707070",
    borderRadius: 20,
    padding: 20,
    marginTop: "20px",
    minWidth: 0,
    [down.sm]: {
      padding: 12,
      borderRadius: 14,
    },
  },

  containerHistorique: {
    display: "flex",
    flexWrap: "wrap",
    gap: "50px",
    marginBottom: 40,
    padding: "0px 16px",
    [down.sm]: {
      flexDirection: "column",
      gap: "20px",
      marginBottom: 24,
      padding: "0px 4px",
    },
  },
  containerYears: {
    cursor: "pointer",
    display: "flex",
    gap: "20px",
    color: "#CECBCB",
    fontFamily: "Poppins-Bold",
    fontSize: 15,
    flexWrap: "wrap",
  },
  isMenuYearSelected: {
    color: "#FF6F04",
  },
  historiqueList: {
    /*
     * `height: calc(100vh - 400px)` hard-coded everything above it. On a
     * laptop at 768px tall that resolved to 368px; on a phone in landscape it
     * went negative and the list collapsed to nothing. A max-height against
     * the shell-aware `--app-height` degrades gracefully instead.
     */
    maxHeight: "calc(var(--app-height) - 400px)",
    minHeight: 200,
    padding: "0px 20px",
    overflowY: "auto",
    [down.sm]: {
      maxHeight: "none",
      padding: "0px 4px",
    },
    "&::-webkit-scrollbar": {
      width: 6,
      height: 8,
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: 6,
      background: "#FF6F08",
      boxShadow: "inset 0 0 6px rgb(0 0 0 / 50%)",
    },
    "& >div:last-child": {
      border: 0,
    },
  },
  historiqueItemContainer: {
    position: "relative",
    borderLeft: "1px solid #FF6F04",
    padding: "0px 20px 30px",
  },
  iconVerification: {
    position: "absolute",
    top: 0,
    left: -12,
  },
  iconProprietaire: { 
    position: "absolute", 
    top: 0, 
    left: -7 
  },
  historiqueRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 30,
    minHeight: "70px",
    minWidth: 0,
    overflow: "visible",
    [down.sm]: {
      gap: 12,
    },
    "& .year": {
      fontFamily: "Poppins-Regular",
      fontSize: 14,
    },
    "& .revision": {
      fontFamily: "Poppins-Bold",
      fontSize: 14,
      flex: "none",
      width: "140px",
    },
    // Add vehicle info styling
    "& .vehicle-info": {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      flex: 1,
    },
    "& .vehicle-info-title": {
      fontFamily: "Poppins-Bold",
      fontSize: 14,
      color: "#312B27",
      marginBottom: "8px",
    },
    "& .vehicle-info-item": {
      display: "flex",
      justifyContent: "space-between",
      fontSize: 12,
      padding: "2px 0",
      "& .label": {
        fontFamily: "Poppins-Regular",
        color: "#ADADAD",
        flex: "0 0 auto",
      },
      "& .value": {
        fontFamily: "Poppins-Regular",
        color: "#312B27",
        textAlign: "right",
        marginLeft: "10px",
        wordWrap: "break-word",
      },
    },
  },
  notes: {
    "& .notes": {
      fontFamily: "Poppins-Bold",
      fontSize: 12,
    },
    "& p": {
      margin: 0,
      padding: 0,
      fontFamily: "Poppins-Regular",
      fontSize: 12,
    },
  },
  buttonDocument: {
    textWrap: "nowrap",
    backgroundColor: "#E2E2E2",
    padding: "1px 22px",
    borderRadius: "50px",
    fontSize: "12px",
    fontFamily: "Poppins-Bold",
    color: "#312B27",
    border: 0,
    textTransform: "uppercase",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#D0D0D0",
    },
  },
  prestataire: {
    "& .prestataireName": {
      fontFamily: "Poppins-Bold",
      fontSize: 12,
      textDecoration: "underline",
      textWrap: "nowrap",
    },
    "& .ville": {
      fontFamily: "Poppins-Regular",
      fontSize: 12,
    },
  },
  expendMore: {
    backgroundColor: "#FF6F041A",
    textAlign: "center",
    height: "24px",
    cursor: "pointer",
    marginTop: 5,
    borderBottom: "1px solid #ADADAD",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "#FF6F0830",
    },
  },

  beforeRetranscription: {
    minHeight: "var(--app-height)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "24px 16px",
    backgroundColor: colors.WHITE,
    "& >div": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      /* Was a flat 650px, i.e. wider than most laptops once the sidebar is
         accounted for, and roughly twice the width of a phone. */
      width: "100%",
      maxWidth: "650px",
      gap: "20px",
    },
  },
  beforeTextfield: {
    "& .MuiInputBase-input": {
      fontFamily: "Poppins-Regular",
    },
    "& .MuiInputBase-root": {
      borderRadius: 21,
    },
    "& .MuiOutlinedInput-notchedOutline": {},
  },
  beforeButtom: {
    width: "100%",
    height: "31px",
    borderRadius: "50px",
    color: "#0898FF",
    fontFamily: "Poppins-Bold",
    fontSize: "14px",
    margin: "0",
    backgroundColor: "white",
    border: 0,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  },
  documentsContainer: {
    marginTop: '12px',
    padding: '8px 0',
    borderTop: '1px solid #e0e0e0',
    '& .documents-label': {
      fontSize: '14px',
      fontWeight: '600',
      color: '#333',
      marginBottom: '8px',
    },
  },

  documentsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },

  documentLink: {
    display: 'inline-block',
    padding: '6px 12px',
    backgroundColor: '#f5f5f5',
    color: '#0066cc',
    textDecoration: 'none',
    borderRadius: '4px',
    fontSize: '13px',
    fontWeight: '500',
    border: '1px solid #ddd',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#e8f4f8',
      borderColor: '#0066cc',
      textDecoration: 'none',
    },
    '&:focus': {
      outline: '2px solid #0066cc',
      outlineOffset: '2px',
    },
  },

  // Additional styles for better vehicle information display
  vehicleInfoContainer: {
    backgroundColor: "#f9f9f9",
    padding: "16px",
    borderRadius: "8px",
    marginTop: "16px",
    border: "1px solid #e0e0e0",
  },
  
  /* Auto-fit rather than a hard 2-to-1 switch, so the pair of columns
     collapses exactly when the cells stop fitting. */
  vehicleInfoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(min(220px, 100%), 1fr))",
    gap: "12px",
  },
  
  vehicleInfoRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 0",
    borderBottom: "1px solid #e0e0e0",
    "&:last-child": {
      borderBottom: "none",
    },
  },
}));

export default useStyles;